module.exports = __webpack_public_path__ + "assets/img/home-selected-report.a05c2ea3.png";